<template>
	<div class="softphone-cls">
		<!-- 电话声音 -->
		<audio id="ringMusic" loop>
			<source :src="`${cdnUrl}/static/media/incoming-call.wav`" type="audio/mpeg">
		</audio>
		<audio id="localAudio"></audio>
		<audio id="remoteAudio"></audio>
		<!-- 电话开关 -->
		<section class="phone-btn-cls" @click.stop="handleExpand"></section>

		<section class="container" id="con">
			<section class="fixed-container-cls">
				<div @click.stop="handleTelOperate('签出')" class="cell" :class="{'disable': !handleStatusMap().includes('签出'), 'theme-out': StoreIsSignIn}" v-if="StoreIsSignIn">
					<svg-icon icon-class="checkOut" />
					<span>签出</span>
				</div>
				<div @click.stop="handleTelOperate('签入')" class="cell" :class="{'disable': !handleStatusMap().includes('签入'), 'theme-in': !StoreIsSignIn}" v-else>
					<svg-icon icon-class="checkIn" />
					<span>签入</span>
				</div>
				<div @click.stop="handleTelOperate('置闲')" class="cell" :class="{'disable': !handleStatusMap().includes('置闲')}">
					<svg-icon icon-class="Idle" />
					<span>置闲</span>
				</div>
				<div @click.stop="handleTelOperate('置忙')" class="cell" :class="{'disable': !handleStatusMap().includes('置忙')}">
					<svg-icon icon-class="Busy" />
					<span>置忙</span>
				</div>
				<div @click.stop="handleTelOperate('挂断')" class="cell" :class="{'disable': !handleStatusMap().includes('挂断')}" v-if="StoreIsAnswer || StoreIsBusyReasonList.includes(StoreIsBusyReason)">
					<svg-icon icon-class="hangUp" />
					<span>挂断</span>
				</div>
				<div @click.stop="handleTelOperate('接听')" class="cell" :class="{'disable': !handleStatusMap().includes('接听')}" v-if="!StoreIsAnswer && !StoreIsBusyReasonList.includes(StoreIsBusyReason)">
					<svg-icon :icon-class="StoreIsCall ? 'Answer2' : 'Answer'" :class="StoreIsCall && ! StoreIsAnswer ? 'answer' : ''" />
					<span :class="StoreIsCall && !StoreIsAnswer ? 'answer' : ''">接听</span>
				</div>
			</section>

			<section class="drag-container-cls">
				<draggable v-model="fixedArray" group="site" animation="100" @end="onEnd">
					<transition-group>
						<div @click.stop="handleTelOperate(StoreIsKeep && item.name === '保持' ? '恢复' : item.name)" class="cell" :class="{'disable': !handleStatusMap().includes(StoreIsKeep && item.name === '保持' ? '恢复' : item.name)}" v-for="item in fixedArray" :key="item.id">
							<svg-icon :icon-class="item.icon" />
							<span>{{StoreIsKeep && item.name === '保持' ? '恢复' : item.name}}</span>
							<div class="btn-madel" v-show="btnMadel === item.name">
								<Keyboard :sipDriver="sipDriver" />
							</div>
						</div>
					</transition-group>
				</draggable>
			</section>

			<section class="more-container-cls">
				<div class="cell" @click.stop="handleMore">
					<svg-icon icon-class="More" />
					<span>更多</span>
				</div>
				<div class="more-madel" v-show="isMore">
					<draggable v-model="hiddenArray" group="site" animation="100" :move="onMove" @end="onEnd">
						<transition-group>
							<div @click.stop="handleTelOperate(StoreIsKeep && item.name === '保持' ? '恢复' : item.name)" class="cell" :class="{'disable': !handleStatusMap().includes(StoreIsKeep && item.name === '保持' ? '恢复' : item.name)}" v-for="item in hiddenArray" :key="item.id">
								<svg-icon :icon-class="item.icon" />
								<span>{{StoreIsKeep && item.name === '保持' ? '恢复' : item.name}}</span>
							</div>
						</transition-group>
					</draggable>
				</div>
			</section>
			<section v-if="StoreIsCall" class="huoyue-container-cls">
				<div class="top-cls">
					<svg-icon icon-class="TelSignal4" />
					<svg-icon :icon-class="StoreIsIdle ? 'IBicon' : 'OBicon'" />
					<span>{{StoreIsBusy ? (isShowPhone ? $$(StoreIsCallCurrentInfo, 'phone') : hiddenPhone($$(StoreIsCallCurrentInfo, 'phone'))) : (isShowPhone ? $$(StoreIsCallCurrentInfo, 'callerid') : hiddenPhone($$(StoreIsCallCurrentInfo, 'callerid')))}}</span>
				</div>
				<div class="bottom-cls">
					<svg-icon @click.stop="handleMute" :icon-class="isMute ? 'Shut' : 'Flush'" />
					<svg-icon :icon-class="StoreIsAnswer ? 'Telthz' : 'Telhangon'" />
					<span :style="{'color': StoreIsAnswer ? '#47B267' : '#FF504D'}">{{StoreCallTime}}</span>
				</div>
			</section>
		</section>

		<!-- 签入 | 签出 -->
		<el-dialog :modal-append-to-body="false" :title="(StoreIsSignIn ? '签出' : '签入') + '软电话'" :visible.sync="dialogVisibleCheckSign" width="500px" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
			<Sign v-if="dialogVisibleCheckSign === true" :sipDriver="sipDriver" @signClose="dialogVisibleCheckSign = false;" />
		</el-dialog>

		<!-- 置闲 -->
		<el-dialog :modal-append-to-body="false" title="请选择置闲原因" :visible.sync="dialogVisibleIdle" width="300px" center :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
			<Busy :manageAux="manageAux" @signClose="dialogVisibleIdle = false;" />
		</el-dialog>

		<!-- 置忙 -->
		<el-dialog :modal-append-to-body="false" title="请选择置忙原因" :visible.sync="dialogVisibleBusy" width="300px" center :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
			<Busy :manageAux="manageAux" @signClose="dialogVisibleBusy = false;" />
		</el-dialog>

		<!-- 外呼 -->
		<el-dialog :modal-append-to-body="false" title="外呼" :visible.sync="dialogVisibleBreathe" width="320px" center :close-on-press-escape="false" :close-on-click-modal="false">
			<Breathe v-if="dialogVisibleBreathe" :sipDriver="sipDriver" @signClose="dialogVisibleBreathe = false;" />
		</el-dialog>

		<!-- 转接 -->
		<el-dialog :modal-append-to-body="false" title="转接" :visible.sync="dialogVisibleTransfer" width="320px" center :close-on-press-escape="false" :close-on-click-modal="false">
			<Transfer v-if="dialogVisibleTransfer" :sipDriver="sipDriver" @signClose="dialogVisibleTransfer = false;" />
		</el-dialog>

		<!-- 协商 -->
		<el-dialog :modal-append-to-body="false" title="协商转接" :visible.sync="dialogVisibleNegotiate" width="320px" center :close-on-press-escape="false" :close-on-click-modal="false">
			<Negotiate v-if="dialogVisibleNegotiate" :sipDriver="sipDriver" @signClose="dialogVisibleNegotiate = false;" />
		</el-dialog>

		<!-- 会议 -->
		<el-dialog :modal-append-to-body="false" title="会议" :visible.sync="dialogVisibleMeeting" width="320px" center :close-on-press-escape="false" :close-on-click-modal="false">
			<Meeting v-if="dialogVisibleMeeting" :sipDriver="sipDriver" @signClose="dialogVisibleMeeting = false;" />
		</el-dialog>

		<!-- 监控 -->
		<el-dialog :modal-append-to-body="false" title="监控" :visible.sync="dialogVisibleMonitor" width="320px" center :close-on-press-escape="false" :close-on-click-modal="false">
			<Monitor v-if="dialogVisibleMonitor" :sipDriver="sipDriver" @signClose="dialogVisibleMonitor = false;" />
		</el-dialog>

		<!-- 信息 -->
		<el-dialog :modal-append-to-body="false" title="软电话信息" :visible.sync="dialogVisibleInfo" width="500px" :close-on-press-escape="false" :close-on-click-modal="false">
			<Info />
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Sign from './Sign';
import Idle from './Idle';
import Busy from './Busy';
import Breathe from './Breathe';
import Transfer from './Transfer';
import Meeting from './Meeting';
import Monitor from './Monitor';
import Negotiate from './Negotiate';
import Keyboard from './Keyboard';
import Info from './Info';
import { sipInit } from './jsSipFun';

export default {
	name: 'SoftphoneCompoment',
	props: ['telPermission'],
	components: {Sign, Idle, Busy, Breathe, Transfer, Meeting, Monitor, Negotiate, Keyboard, Info},
	computed: {
		...mapGetters([
			'userInfo',
			'StoreAgentInfo', // ~ agent电话相关信息
			'StoreSingInCategory', // ~ 签入类型
			'StoreIsSignIn', // ~ 是否签入
			'StoreIsIdle', // ~ 是否置闲
			'StoreIsBusy', // ~ 是否置忙
			'StoreIsBusyReason', // ~ 置闲 / 置忙原因
			'StoreIsCall', // ~ 是否来电
			'StoreIsAnswer', // ~ 是否接听
			'StoreIsKeep', // ~ 是否保持
			'StoreIsCallCurrentInfo', // ~ 当前来电信息
			'StoreCallTime', // ~ 通话时间
			'StoreIsBusyReasonList', // ~ 可外呼的置忙原因
			'StoreIsMonitor', // ~ 是否正在监控
			'isShowPhone',
			'StoreAuxList'
		]),
		StatusMap() {
			const {StoreIsSignIn, StoreIsIdle, StoreIsBusy, StoreIsBusyReason, StoreIsCall, StoreIsAnswer, StoreIsKeep, StoreAuxList} = this;
			return {
				StoreIsSignIn, 
				StoreIsIdle, 
				StoreIsBusy, 
				StoreIsBusyReason, 
				StoreIsCall, 
				StoreIsAnswer, 
				StoreIsKeep,
				StoreAuxList
			};
		}
	},
	data() {
		return {
			loading: false,
			isTeamLeader: false,
			isHideContainer: true,
			isMute: false,
			isMore: false,
			btnMadel: '',
			fixedArray: [
				{id: 1, name: "保持", icon: "Keep"},
				{id: 2, name: "转接", icon: "Transfer"},
				{id: 3, name: "外呼", icon: "breathe"},
				{id: 4, name: "协商", icon: "Negotiate"},
				{id: 5, name: "满意度", icon: "Satisfaction"},
			],
			hiddenArray: [
				{id: 6, name: "按键", icon: "button"},
				{id: 7, name: "会议", icon: "Meeting"},
				{id: 8, name: "监控", icon: "monitor"},
				{id: 9, name: "信息", icon: "info"},
			],
			isTimeout: '',
			dialogVisibleCheckSign: false,
			dialogVisibleIdle: false,
			dialogVisibleBusy: false,
			dialogVisibleBreathe: false,
			dialogVisibleTransfer: false,
			dialogVisibleMeeting: false,
			dialogVisibleMonitor: false,
			dialogVisibleNegotiate: false,
			dialogVisibleInfo: false,
			sipDriver: null,
			manageAux: [],
			isMo: false,
			cdnUrl: process.env.VUE_APP_BASE_CDN,
		}
	},
	mounted() {
		const self = this;
		document.getElementById('app').onclick = function() {
			self.isMore = false;
			self.btnMadel = '';
		}
		if(self.StoreIsSignIn) {
			self.SET_RESET_JS_SIP_SETTING();
			self.sipDriver._init(self.StoreSingInCategory);
		}
		window.addEventListener('storage', function (e) {
			console.log(e)
			if(e.key && e.key == 'IframePageOB' && e.newValue){
				const IframePageOB = JSON.parse(localStorage.getItem('IframePageOB'));
				console.log('打电话');
				console.log(IframePageOB);
				self.SET_IS_CALL(true);
				self.SET_IS_ANSWER(false);
				self.sipDriver._call(IframePageOB.calledNumber, {
					brandId: self.userInfo.brandIdentify,
					channelId: 'phone',
					direction: 'OB',
					callingNumber: self.userInfo.deviceCode,
					calledNumber: IframePageOB.calledNumber,
					csrUserId: self.userInfo.userId,
					csrUserName: self.userInfo.nickname,
					startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
				}, '*5', 'IframePageOB');
			}
		});
	},
	watch: {
		isHideContainer(val) {
			if (val) {
				clearTimeout(this.isTimeout);
				document.getElementById('con').style.overflow = 'hidden';
			} else {
				this.isTimeout = setTimeout(() => {
					document.getElementById('con').style.overflow = 'visible';
				}, 200);
			}
		},
		StatusMap: {
			handler() {
				this.handleStatusMap();
			},
			immediate:true,
			deep: true
		},
	},
	created() {
		this.SET_SOFT_PHONE_IN_MSG({
			msg: '坐席信息',
			data: {
				brandIdentify: this.userInfo.brandIdentify,
				agentCode: this.userInfo.agentCode,
				deviceCode: this.userInfo.deviceCode,
				userId: this.userInfo.userId
			}
		});
		if(localStorage.getItem('SET-SOFTPHONE-ARR-1') && localStorage.getItem('SET-SOFTPHONE-ARR-1') != 'undefined') {
			this.fixedArray = JSON.parse(localStorage.getItem('SET-SOFTPHONE-ARR-1'));
		}

		if(localStorage.getItem('SET-SOFTPHONE-ARR-2') && localStorage.getItem('SET-SOFTPHONE-ARR-2') != 'undefined') {
			this.hiddenArray = JSON.parse(localStorage.getItem('SET-SOFTPHONE-ARR-2'));
		}
		this.sipDriver = sipInit();
		for(const item of this.telPermission) {
			if(item.viewUrl === 'code://auth-tl') {
				this.isTeamLeader = true;
			}
		}
	},
	methods: {
		...mapMutations({
			'SET_RESET_JS_SIP_SETTING': 'telService/SET_RESET_JS_SIP_SETTING',
			'SET_SOFT_IS_BUSY_REASON_LIST': 'telService/SET_SOFT_IS_BUSY_REASON_LIST',
			'SET_SOFT_PHONE_IN_MSG': 'telService/SET_SOFT_PHONE_IN_MSG',
			'SET_AGENT_INFO': 'telService/SET_AGENT_INFO',
			'SET_IS_IDLE': 'telService/SET_IS_IDLE',
			'SET_IS_BUSY': 'telService/SET_IS_BUSY',
			'SET_IS_CALL': 'telService/SET_IS_CALL',
			'SET_IS_KEEP': 'telService/SET_IS_KEEP',
			'SET_IS_ANSWER': 'telService/SET_IS_ANSWER'
		}),
		handleTelOperate(type) {
			this.SET_SOFT_PHONE_IN_MSG({
				msg: `点击软电话条按钮 - ${type}`,
				data: {}
			});
			if(!this.handleStatusMap().includes(type)) {
				this.SET_SOFT_PHONE_IN_MSG({
					msg: `handleStatusMap - false`,
					data: {}
				});
				return;
			}
			this.SET_SOFT_PHONE_IN_MSG({
				msg: `handleStatusMap - true`,
				data: {}
			});
			switch(type) {
				case '签入': {
					// ! 查询agent电话相关信息
					this.$api.apiPostCallAgentInfo({
						projectCode: this.userInfo.brandIdentify,
						agentName: this.userInfo.agentCode,
						agentContact: this.userInfo.deviceCode
					}).then(response => {
						if(response.errcode != 0) {
							this.SET_SOFT_PHONE_IN_MSG({
								msg: '获取AgentInfo失败',
								data: {
									errmsg: response.errmsg
								}
							});
							return;
						};
						this.SET_SOFT_PHONE_IN_MSG({
							msg: '获取AgentInfo成功',
							data: {
								data: response?.data
							}
						});
						this.SET_AGENT_INFO(response.data);
						this.dialogVisibleCheckSign = true;
					});
					break;
				}
				case '签出': {
					this.dialogVisibleCheckSign = true;
					break;
				}
				case '置闲': {
					// ! 置闲
					this.$api.apiPostCallAuxList({projectCode: this.userInfo.brandIdentify, auxType: 1}).then(response => {
						if(response.errcode != 0) {
							this.SET_SOFT_PHONE_IN_MSG({
								msg: '获取置闲原因失败',
								data: {
									errmsg: response?.errmsg
								}
							});
							return;
						};
						if(response.data.length > 1) {
							this.manageAux = response.data;
							this.dialogVisibleIdle = true;
						} else {
							this.$api.apiPostCallSetWaiting({agentName: this.userInfo?.agentCode}).then(res => {
								if(res.errcode != 0) {
									this.SET_SOFT_PHONE_IN_MSG({
										msg: '置闲失败',
										data: {
											errmsg: res?.errmsg
										}
									});
									return;
								};
								this.SET_IS_IDLE(true);
								this.SET_IS_BUSY({
									StoreIsBusy: false, 
									StoreIsBusyReason: '置闲'
								});
								this.$message.success({message: `置闲成功`, offset: 70});
								this.SET_SOFT_PHONE_IN_MSG({
									msg: '置闲成功',
									data: {
										data: res?.data
									}
								});
							});
						}
					});
					break;
				}
				case '置忙': {
					// ! 置忙状态列表
					this.$api.apiPostCallAuxList({projectCode: this.userInfo.brandIdentify, auxType: 0}).then(response => {
						if(response.errcode != 0) {
							this.SET_SOFT_PHONE_IN_MSG({
								msg: '获取置忙原因失败',
								data: {
									errmsg: response?.errmsg
								}
							});
							return;
						};
						this.SET_SOFT_PHONE_IN_MSG({
							msg: '获取置忙原因列表',
							data: {
								data: response?.data
							}
						});
						this.manageAux = response.data;
						let arr = [];
						for(const item of this.manageAux) {
							if(item.isOnline == '1') {
								arr.push(item.auxDesc);
							}
						}
						this.SET_SOFT_IS_BUSY_REASON_LIST(arr);
						this.dialogVisibleBusy = true;
					});
					break;
				}
				case '接听': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击接听按钮'
					});
					this.sipDriver._answer();
					break;
				}
				case '挂断': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击挂断按钮'
					});
					this.sipDriver._terminate();
					break;
				}
				case '保持': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击保持按钮'
					});
					this.sipDriver._hold();
					this.SET_IS_KEEP(true);
					break;
				}
				case '恢复': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击恢复按钮'
					});
					this.sipDriver._hold();
					this.SET_IS_KEEP(false);
					break;
				}
				case '满意度': {
					const self = this;
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击满意度按钮'
					});
					self.$confirm('您是否要转接满意度？', '满意度', {
						distinguishCancelAndClose: true,
						confirmButtonText: '是',
						cancelButtonText: '否'
					}).then(() => {
						if(self.StoreAgentInfo.satisfyIvr) {
							self.sipDriver._refer(`*4${self.StoreAgentInfo.satisfyIvr}`);
							self.SET_SOFT_PHONE_IN_MSG({
								msg: '转接满意度, 号码: *4',
								data: {
									satisfyIvr: self.StoreAgentInfo.satisfyIvr
								}
							});
						} else {
							self.$message.error({message: `品牌没有配置满意度`, offset: 70});
							self.SET_SOFT_PHONE_IN_MSG({
								msg: '品牌没有配置满意度'
							});
						}
					});
					break;
				}
				case '外呼': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击外呼按钮'
					});
					this.dialogVisibleBreathe = true;
					break;
				}
				case '转接': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击转接按钮'
					});
					this.dialogVisibleTransfer = true;
					break;
				}
				case '会议': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击会议按钮'
					});
					this.dialogVisibleMeeting = true;
					break;
				}
				case '监控': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击监控按钮'
					});
					this.dialogVisibleMonitor = true;
					break;
				}
				case '协商': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击协商按钮'
					});
					this.dialogVisibleNegotiate = true;
					break;
				}
				case '按键': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击按键按钮'
					});
					this.btnMadel = type === '按键' ? type : '';
					break;
				}
				case '信息': {
					this.SET_SOFT_PHONE_IN_MSG({
						msg: '点击信息按钮'
					});
					this.dialogVisibleInfo = true;
					break;
				}
			}
		},
		handleExpand() {
			this.isMore = false;
			this.btnMadel = '';
			this.isHideContainer = !this.isHideContainer;
			if(this.isHideContainer) {
				document.getElementById('con').style.width = 0;
			} else {
				document.getElementById('con').style.width = `${(4 + this.fixedArray.length) * 40 + 250}px`;
			}
			
		},
		handleMore() {
			this.btnMadel = '';
			this.isMore = !this.isMore;
		},
		onMove(){
			if (this.fixedArray.length >= 5) {
				if(!this.isMo) this.$message.error('最多展示5个');
				this.isMo = true;
				return false;
			}else {
				return true;
			}
			
		},  
		onEnd(e) {
			localStorage.setItem('SET-SOFTPHONE-ARR-1', JSON.stringify(this.fixedArray));
			localStorage.setItem('SET-SOFTPHONE-ARR-2', JSON.stringify(this.hiddenArray));
			document.getElementById('con').style.width = `${(5 + this.fixedArray.length) * 40 + 250}px`;
		},
		handleMute() {
			this.isMute = !this.isMute;
			this.sipDriver._muted();
		},
		hiddenPhone(phone) {
			if (!phone) return '---';
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		handleStatusMap() {
			if (!this.StoreIsSignIn) {
				// ! 签入前
				return ['签入', '信息'];
			} else if([true, 'true'].includes(this.StoreIsMonitor)) {
				return ['挂断', '信息'];
			} else if ((this.StoreIsSignIn && !this.StoreIsIdle && !this.StoreIsBusy) || (this.StoreIsSignIn && !this.StoreIsIdle && this.StoreIsBusy && !this.StoreIsBusyReason)) {
				// ! 签入后 - 未置闲 - 未置忙
				return ['签出', '置闲', '置忙', '信息'];
			} else if (this.StoreIsSignIn && this.StoreIsIdle && !this.StoreIsCall && this.StoreIsBusyReason !== '后处理') {
				// ! 签入后 - 置闲 - 未来电
				return ['置忙', '信息'];
			}  else if (this.StoreIsSignIn && this.StoreIsIdle && this.StoreIsBusy) {
				// ! 签入后 - 置闲 - 置忙 - 后处理
				return ['签出', '置闲', '置忙', '信息'];
			} else if (this.StoreIsSignIn && this.StoreIsIdle && this.StoreIsCall && !this.StoreIsAnswer) {
				// ! 签入后 - 置闲 - 来电 - 未接听
				return ['接听', '信息'];
			} else if (this.StoreIsSignIn && this.StoreIsIdle && this.StoreIsCall && this.StoreIsAnswer && !this.StoreIsKeep) {
				// ! 签入后 - 置闲 - 来电 - 接听中 - 未保持
				return ['挂断', '转接', '保持', '协商', '按键', '满意度', '会议', '信息'];
			} else if (this.StoreIsSignIn && this.StoreIsIdle && this.StoreIsCall && this.StoreIsAnswer && this.StoreIsKeep) {
				// ! 签入后 - 置闲 - 来电 - 接听中 - 保持
				return ['恢复', '信息'];
			} else if (this.StoreIsSignIn && this.StoreIsBusy) {
				// let originData = ['无原因置忙', '培训', '后处理', '小休', '外呼', '指导', '就餐', '开会', 'Reserved'];
				let originData = [];
				for(const item of this.StoreAuxList) {
					originData.push(item.auxDesc);
				}
				let tem = JSON.parse(JSON.stringify(this.StoreIsBusyReasonList));
				let results = [];
				originData.forEach((a)=>{
					let c = tem.findIndex(b=>a == b);
					if (c > -1) delete tem[c];
					else results.push(a);
				});
				if(results.includes(this.StoreIsBusyReason)) {
					// ! 签入后 - 置忙 - '无原因置忙', '培训', '后处理', '小休', '就餐', '开会', 'Reserved'
					return this.isTeamLeader ? ['签出', '置闲', '置忙', '监控', '信息'] : ['签出', '置闲', '置忙', '信息'];
				} else if (this.StoreIsBusyReasonList.includes(this.StoreIsBusyReason) && !this.StoreIsCall) {
					// ! 签入后 - 置忙 - '外呼', '指导' - 未来电
					return this.isTeamLeader ? ['签出', '置闲', '置忙', '外呼', '监控', '信息'] : ['签出', '置闲', '置忙', '外呼', '信息'];
				} else if (this.StoreIsBusyReasonList.includes(this.StoreIsBusyReason) && this.StoreIsCall && !this.StoreIsAnswer) {
					// ! 签入后 - 置忙 - '外呼', '指导' - 来电 - 未接听
					return ['挂断', '信息'];
				} else if (this.StoreIsBusyReasonList.includes(this.StoreIsBusyReason) && this.StoreIsCall && this.StoreIsAnswer && !this.StoreIsKeep) {
					// ! 签入后 - 置忙 - '外呼', '指导' - 来电 - 接听 - 未保持
					return ['挂断', '转接', '保持', '协商', '按键', '满意度', '会议', '信息'];
				} else if (this.StoreIsBusyReasonList.includes(this.StoreIsBusyReason) && this.StoreIsCall && this.StoreIsAnswer && this.StoreIsKeep) {
					// ! 签入后 - 置忙 - '外呼', '指导' - 来电 - 接听 - 保持
					return ['恢复', '信息'];
				}
			} else {
				return ['签入', '信息'];
			}
		}
	}
}
</script>

<style lang="scss" scoped>
	.softphone-cls {
		// width: 700px;
		height: 60px;

		&>.phone-btn-cls {
			outline: none;
			display: inline-block;
			width: 50px;
			height: 60px;
			background-image: url('../../assets/softphone.png');
			background-repeat: no-repeat;
			background-size: 40px 40px;
			background-position: 0 10px;
			opacity: 0.8;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		&>.container {
			width: 0;
			height: 60px;
			transition: width .2s;
			overflow: hidden;
			display: inline-block;
			vertical-align: top;

			&>.fixed-container-cls {
				white-space: nowrap;
				display: inline-block;
				vertical-align: top;
				width: 170px;
				height: 60px;
				position: relative;

				&::before {
					content: "";
					width: 1.5px;
					height: 28px;
					position: absolute;
					top: 16px;
					right: 5px;
					background: #C6D1DD;
				}
			}

			&>.drag-container-cls {
				white-space: nowrap;
				display: inline-block;
				vertical-align: top;
				height: 60px;

				& > div > span {
					display: block;
					min-width: 10px;
					height: 60px;
				}
			}

			& .cell {
				display: inline-block;
				width: 40px;
				height: 100%;
				text-align: center;
				padding: 15px 0;
				box-sizing: border-box;
				cursor: pointer;
				color: #3C4353;
				position: relative;

				&.theme-in {
					color: #337EFF;
				}

				&.theme-out {
					color: #F56C6C;
				}

				&>.btn-madel {
					// width: 300px;
					position: absolute;
					top: 65px;
					left: -30px;
					z-index: 10;
					background: #FFFFFF;
					box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
					border-radius: 4px;
					// padding: 18px 10px;
					box-sizing: border-box;
					padding-bottom: 0;

					&:before {
						content: '';
						width: 0;
						height: 0;
						border: 5px solid transparent;
						border-bottom-color: rgba(0, 0, 0, 0.1);
						position: absolute;
						top: 30px;
						left: 30px;
						margin-top: -40px;
					}

					&:after {
						content: "";
						width: 0;
						height: 0;
						border: 5px solid transparent;
						border-bottom-color: #fff;
						position: absolute;
						top: 30px;
						left: 30px;
						margin-top: -39px;
					}

				}


				&>.svg-icon {
					display: block;
					height: 14px;
					width: 14px;
					margin: 0 auto;
					background-size: cover;
					background-repeat: no-repeat;
					font-size: 14px;
				}

				&>span {
					font-size: 12px;
					
					font-weight: 400;
				}

				&.disable {
					cursor: not-allowed;
					color: #C6D1DD;
				}
			}

			&>.more-container-cls {
				white-space: nowrap;
				display: inline-block;
				vertical-align: top;
				position: relative;

				&>.more-madel {
					width: 116px;
					position: absolute;
					top: 65px;
					left: -30px;
					z-index: 10;
					background: #FFFFFF;
					box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
					border-radius: 4px;
					padding: 18px 10px;
					box-sizing: border-box;
					padding-bottom: 0;

					&:before {
						content: '';
						width: 0;
						height: 0;
						border: 5px solid transparent;
						border-bottom-color: rgba(0, 0, 0, 0.1);
						position: absolute;
						top: 30px;
						left: 30px;
						margin-top: -40px;
					}

					&:after {
						content: "";
						width: 0;
						height: 0;
						border: 5px solid transparent;
						border-bottom-color: #fff;
						position: absolute;
						top: 30px;
						left: 30px;
						margin-top: -39px;
					}

					& .cell {
						width: 40px;
						height: 100%;
						text-align: center;
						box-sizing: border-box;
						cursor: pointer;
						color: #3C4353;
						float: left;
						margin-bottom: 18px;
						padding: 0;
						position: relative;

						&:nth-of-type(2n) {
							margin-left: 8px;
						}

						&>.svg-icon {
							display: block;
							height: 14px;
							width: 14px;
							margin: 0 auto;
							background-size: cover;
							background-repeat: no-repeat;
							font-size: 14px;
						}

						&>span {
							font-size: 12px;
							
							font-weight: 400;
						}

						&.disable {
							cursor: not-allowed;
							color: #C6D1DD;
						}
					}
				}

			}

			&>.huoyue-container-cls {
				display: inline-block;
				// width: 140px;
				height: 100%;
				vertical-align: top;
				box-sizing: border-box;
				padding: 10px 0;
				margin-left: 20px;

				&>div {
					width: 100%;
					height: 18px;

					&.top-cls {
						margin-bottom: 4px;
					}

					&>.svg-icon {
						font-size: 16px;
						margin-right: 6px;
						color: #FF504D
					}

					&>span {
						display: inline-block;
						height: 18px;
						font-size: 14px;
						font-weight: bold;
						color: #FF504D;
						margin-right: 10px;

					}

					&.top-cls>span {
						color: #2B6BCA;
					}

					&.bottom-cls>.svg-icon:nth-of-type(2) {
						cursor: pointer;
						vertical-align: middle;
						margin-top: -1px;
					}
				}
			}
		}
	}

	.answer {
		color: #2B6BCA;
		font-weight: 900;
		animation: shake 800ms infinite linear;
	}

	@keyframes shake {
		10%, 90% {transform: translate3d(-1px, 0, 0);}
		20%, 80% {transform: translate3d(+1.5px, 0, 0);}
		30%, 70% {transform: translate3d(-3px, 0, 0);}
		40%, 60% {transform: translate3d(+3px, 0, 0);}
		50% {transform: translate3d(-3px, 0, 0);}
	}
</style>
